import { render, staticRenderFns } from "./weekly-view-discipline.vue?vue&type=template&id=64ef2734&scoped=true"
import script from "./weekly-view-discipline.vue?vue&type=script&lang=js"
export * from "./weekly-view-discipline.vue?vue&type=script&lang=js"
import style0 from "./weekly-view-discipline.vue?vue&type=style&index=0&id=64ef2734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef2734",
  null
  
)

export default component.exports